import React from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import PropTypes from "prop-types";
import { DEFAULT_IMAGE_URL } from "../../utils/contrains";
import "./print-file-modal.css";

class PrintFileModal extends React.PureComponent {
  componentRef = React.createRef();

  static propTypes = {
    item: PropTypes.object,
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      EnrollName,
      EnrollCode,
      Title,
      Description,
      Teams,
      ContactPerson,
      ContactPhone,
      ContactEmail,
      Department,
      ClassroomTwName,
      AttachedfileA,
      AttachedfileB,
    } = this.props.item;
    return (
      <div className="container">
        <div style={{ textAlign: "center" }}>
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-sm btn-success">列印</button>
            )}
            content={() => this.componentRef.current}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <div ref={this.componentRef}>
            <table
              width="90%"
              border="1"
              style={{ margin: "auto", marginTop: "20px" }}
            >
              <tr>
                <td
                  colspan="4"
                  align="center"
                  valign="middle"
                  className="headfontstyle"
                >
                  <span style={{ fontSize: "24px" }}>
                    <strong>台南應用科技大學 </strong>
                    <p align="center">
                      <strong>「TUT虛擬數位形象大使」徵稿報名表</strong>
                    </p>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  width={"25%"}
                  align="center"
                  valign="middle"
                  className="headfontstyle"
                >
                  <span>姓名</span>
                </td>
                <td valign="middle" className="datafontstyle">
                  {EnrollName}
                </td>
                <td
                  width={"25%"}
                  align="center"
                  valign="middle"
                  className="headfontstyle"
                >
                  <span>學號</span>
                </td>
                <td valign="middle" className="datafontstyle">
                  {EnrollCode}
                </td>
              </tr>
              <tr>
                <td
                  width={"25%"}
                  align="center"
                  valign="middle"
                  className="headfontstyle"
                >
                  <span>科系/年級</span>
                </td>
                <td colspan="3" valign="middle" className="datafontstyle">
                  <span>
                    {Department}/{ClassroomTwName}
                  </span>
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>聯絡資訊</span>
                </td>
                <td colspan="3" valign="middle" className="datafontstyle">
                  <span className="datafontstyle">聯絡人：{ContactPerson}</span>
                  <br />
                  <span className="datafontstyle">
                    手機電話：{ContactPhone}
                  </span>
                  <br />
                  <span className="datafontstyle">信箱:{ContactEmail}</span>
                  <br />
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>團隊成員</span>
                </td>
                <td colspan="3" valign="middle" className="datafontstyle">
                  {Teams}
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>
                    <span>形象大使</span>
                    <br />
                    <span>角色名稱</span>
                  </span>
                </td>
                <td colspan="3" valign="middle" className="datafontstyle">
                  {Title}
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>創作理念</span>
                </td>
                <td colspan="3" valign="middle" className="datafontstyle">
                  {Description}
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>全身立繪</span>
                </td>
                <td colspan="3" align="center" valign="middle">
                  <img
                    src={DEFAULT_IMAGE_URL + AttachedfileA}
                    alt="全身立繪"
                    width={"95%"}
                  />
                </td>
              </tr>
              <tr>
                <td align="center" valign="middle" className="headfontstyle">
                  <span>角色Q版(2頭身)</span>
                </td>
                <td colspan="3" align="center" valign="middle">
                  <img
                    src={DEFAULT_IMAGE_URL + AttachedfileB}
                    alt="角色Q版(2頭身)"
                    width={"95%"}
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(PrintFileModal);
